import { PLATFORM_NAME } from '../../../configs/common';
import { TabHandler } from '../../../handlers/TabHandler';

/**
 * Sets the browser tab title for a job detail page to `<label> <id> | <detail>`
 * — e.g. `Job 12345 | Bourke St Store`.
 *
 * Users routinely keep several job tabs open at once; the trailing detail is
 * what lets them tell background tabs apart without focusing each one. Which
 * detail earns the space differs by job type, so the caller supplies it: a
 * standard job names its location, a repair job names the part's serial (its
 * location is only wherever the part happens to be sitting).
 *
 * @param label     Job-type word leading the title (`Job`, `Repair`).
 * @param serviceId CMS job id from the route. Omitted from the title when the
 *                  route carries no id.
 * @param detail    Trailing segment. When empty — the job hasn't loaded, or
 *                  has no such detail recorded — the title falls back to the
 *                  platform name so the tab never reads with a dangling
 *                  separator.
 */
export const useJobTabTitle = (label: string, serviceId?: string, detail?: string): void => {
  const heading = serviceId ? `${label} ${serviceId}` : label;

  TabHandler(`${heading} | ${detail || PLATFORM_NAME}`);
};
